import { motion } from 'framer-motion';

interface StreakFlameProps {
  streak: number;
  size?: 'sm' | 'lg';
}

export function StreakFlame({ streak, size = 'lg' }: StreakFlameProps) {
  const isActive = streak > 0;
  const sizeClasses = size === 'lg' ? 'text-5xl' : 'text-2xl';
  const numClasses = size === 'lg' ? 'text-2xl' : 'text-sm';

  return (
    <div className="flex flex-col items-center gap-1">
      <motion.div
        className={sizeClasses}
        animate={isActive ? {
          scale: [1, 1.1, 1],
          filter: ['brightness(1)', 'brightness(1.3)', 'brightness(1)'],
        } : {}}
        transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
      >
        {isActive ? '🔥' : '❄️'}
      </motion.div>
      <span className={`display-number ${numClasses} ${isActive ? 'text-warning' : 'text-muted-foreground'}`}>
        {streak}
      </span>
      {size === 'lg' && (
        <span className="text-xs text-muted-foreground font-body">
          {isActive ? 'day streak!' : 'Start a streak!'}
        </span>
      )}
    </div>
  );
}
